module.exports = __webpack_public_path__ + "media/images/crm/shape-square-main-white-3dd7e714a02e8370611bab1df6299289.png";